import { Component, OnInit } from '@angular/core';
import { MiscService } from '../../_service/misc.service';
import { SharedService } from '../../_service/shared.service';
@Component({
  selector: 'app-performance-report',
  templateUrl: './performance-report.component.html',
  styleUrls: ['./performance-report.component.css']
})
export class PerformanceReportComponent implements OnInit {
  todayDate : Date = new Date();
  myrole:string;
  ctoc_performance_loading:boolean=false; today_call_attempts = 0; today_call_connected = 0; today_talk_time = '0';preprt_username='';cashIpdCount = 0;
  constructor(public miscapi:MiscService, private sharedapi:SharedService) {
    this.sharedapi.getRole()
    .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
  }

  ngOnInit(): void {
    this.getbdctocReportList();
  }

  async getbdctocReportList()
  {
    this.ctoc_performance_loading=true;
    await this.miscapi.getbdctocReportData().subscribe((data:any) => {
        this.ctoc_performance_loading=false;
        if(data.status)
        {
          this.preprt_username = data.data[0]['name'];
          if(data.data[0]['total_no_of_call_attempts'] > 0)
          {
            this.today_call_attempts = data.data[0]['total_no_of_call_attempts'];
          } 
          else 
          {
            this.today_call_attempts = 0;
          }
          
          if(data.data[0]['call_connected'] > 0)
          {
            this.today_call_connected = data.data[0]['call_connected'];
          } 
          else 
          {
            this.today_call_connected = 0;
          }
          



          let totalsec = data.data[0]['talk_time'];

          const minutes: number = Math.floor(totalsec / 60);
          const seconds: number = totalsec % 60;
          let loc_min = '';
          if(minutes > 0)
          {
            loc_min += minutes+ " Min " 
          }
          if(seconds > 0)
          {
            loc_min += seconds+ " Sec" 
          }

          if(loc_min)
          {
            this.today_talk_time = loc_min;
          } 
          else 
          {
            this.today_talk_time = '0';
          }

          if(data.data[0]['cashIpdCount'] > 0){
            this.cashIpdCount = data.data[0]['cashIpdCount'];
          }

        }else{
          this.sharedapi.presentToast('Something went wrong. Please try again.');
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }
}
